import { z } from "zod/v4";
import { defineResource, defineEndpoint } from "@visioni/a3s-client-api";
import { FEATURE_NAME } from "../constants";
import { PhoneNumber } from "../schema";

/**
 * Client-API resource surface for self-service notification contact info
 * (currently just a phone number for SMS). Tenant-scoped, not camera-scoped
 * (`scope: "tenant"`) — like `notification-preferences`, this always belongs
 * to the calling user (`actor` from `requireAuth()`), never a
 * path/body-supplied user id.
 */

export const notificationContactInfoResource = defineResource({
  feature: FEATURE_NAME,
  resource: "notification-contact-info",
  scope: "tenant",
});

export const GetContactPhoneNumberResponse = z.object({
  phoneNumber: PhoneNumber.nullable(),
});
export type GetContactPhoneNumberResponse = z.infer<typeof GetContactPhoneNumberResponse>;

/** GET the calling user's phone number for notification delivery, or `null` if never set. */
export const getContactPhoneNumberEndpoint = defineEndpoint(notificationContactInfoResource, {
  responseSchema: GetContactPhoneNumberResponse,
});

export const SetContactPhoneNumberBody = z.object({
  phoneNumber: PhoneNumber.nullable(),
});
export type SetContactPhoneNumberBody = z.infer<typeof SetContactPhoneNumberBody>;

/** PUT the calling user's phone number for notification delivery, or clear it with `null`. */
export const setContactPhoneNumberEndpoint = defineEndpoint(notificationContactInfoResource, {
  method: "PUT",
  bodySchema: SetContactPhoneNumberBody,
  responseSchema: GetContactPhoneNumberResponse,
});
